import {
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
} from "node-library/dist/portal";

export function getTestCategoryMatrixMap(
	orderTestCategory: FrontendCompanyTestCategory
): Map<string, Array<FrontendCompanySampleMatrix>> {
	const groupedMap = new Map<string, FrontendCompanySampleMatrix[]>();

	orderTestCategory.sampleMatrices.forEach(
		(item: FrontendCompanySampleMatrix) => {
			if (!groupedMap.has(item.matrix)) {
				groupedMap.set(item.matrix, [item]);
			} else {
				groupedMap.get(item.matrix)?.push(item);
			}
		}
	);
	return groupedMap;
}
